import type { FC } from 'react';
import { memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { useMeinOrtTab } from '@/features/mein-ort/components/MeinOrtTabContext';
import type { MeinOrtChannel } from '@/features/mein-ort/components/meinOrtTypes';
import { PillSegmentedButtons } from '@/shared/components/PillSegmentedButtons';

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 5
  }
});

export const MeinOrtChannelSelector: FC = memo(() => {
  const { channelConfigs, activeChannel, onChannelChange } = useMeinOrtTab();

  const buttons = useMemo(
    () =>
      channelConfigs.map(({ key, label }) => ({
        value: key,
        label,
        testID: `mein-ort-channel-${key}`
      })),
    [channelConfigs]
  );

  return (
    <PillSegmentedButtons<MeinOrtChannel>
      style={styles.container}
      value={activeChannel}
      onValueChange={onChannelChange}
      buttons={buttons}
    />
  );
});
MeinOrtChannelSelector.displayName = 'MeinOrtChannelSelector';
